import React from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import BaseButton from "../Common/Buttons/BaseButton";

const RagEditBody = ({ state, setState, isEdit, setIsEdit }) => {
  const { question, answer } = state;
  return (
    <>
      {isEdit ? (
        <Box>
          <Box>
            <Typography className="font-14-grey mb-2">Question</Typography>
            <TextField
              name="question"
              value={question}
              onChange={(e) =>
                setState((prev) => ({
                  ...prev,
                  question: e.target.value,
                }))
              }
              variant="outlined"
              fullWidth
              placeholder="Enter Question"
              multiline
              rows={4}
              sx={commonStyles.inputField}
            />
          </Box>
          <Box className="mt-3">
            <Typography className="font-14-grey mb-2">Answer</Typography>
            <TextField
              name="answer"
              value={answer}
              onChange={(e) =>
                setState((prev) => ({
                  ...prev,
                  answer: e.target.value,
                }))
              }
              variant="outlined"
              fullWidth
              placeholder="Enter Answer"
              multiline
              rows={4}
              sx={commonStyles.inputField}
            />
          </Box>
        </Box>
      ) : (
        <Box>
          <Box>
            <Typography className="font-16-700-grey mb-1">Question</Typography>
            <Box className="font-14-grey">{question}</Box>
          </Box>
          <Box className="mt-3">
            <Typography className="font-16-700-grey mb-1">Answer</Typography>
            <Box className="font-14-grey">{answer}</Box>
          </Box>
          <BaseButton
            title="Edit"
            variant="outlined"
            handleClick={() => setIsEdit(true)}
            styles={{ px: 2, fontSize: 12, mt: 2 }}
          />
        </Box>
      )}
    </>
  );
};

export default RagEditBody;
